import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { Disclosure } from 'core/components';
import { boxPadding } from 'core/modifiers';

export default class PageHvnPeeringsDetailTabsContentAzureCompletionSteps extends Component {
  <template>
    <Disclosure
      data-test-peerings-content-tabs-terraform-azure-disclosure
      @label={{t
        "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.disclosure.label"
      }}
    >
      <div {{boxPadding "md 0 0 0"}}>
        <div data-test-peering-content-tabs-completion-steps-azure>
          <ol start={{@startListNumber}}>
            <li>
              {{t
                "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.step-one"
              }}
            </li>
            <li>
              {{t
                "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.step-two"
                htmlSafe=true
              }}
            </li>
          </ol>
        </div>
      </div>
    </Disclosure>
  </template>
}
